import {
  SET_PHASE,
  SET_OPTIONS,
  SET_SELECTED,
  TOGGLE_SECTION,
  SET_ERROR,
  SET_RESULT,
  RESET_BACKUP,
  SET_LAST_BACKUP_TIME,
} from "../../action/backup/backupType";

const initialState = {
  phase: "loading", // loading | ready | generating | downloading | done | error
  option: [], // [{ key, label, count }]
  selected: [], // ["lawsuits", "contacts", ...]
  lastBackup: null,
  errorMsg: "",
  resultFile: null,
};

const backupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PHASE:
      return {
        ...state,
        phase: action.payload,
      };

    case SET_OPTIONS:
      return {
        ...state,
        option: action.payload,
      };

    case SET_LAST_BACKUP_TIME:
      return {
        ...state,
        lastBackup: action.payload,
      };

    case SET_SELECTED:
      return {
        ...state,
        selected: action.payload,
      };

    case TOGGLE_SECTION: {
      const key = action.payload;
      const isSelected = state.selected.includes(key);
      return {
        ...state,
        selected: isSelected
          ? state.selected.filter((k) => k !== key)
          : [...state.selected, key],
      };
    }

    case SET_ERROR:
      return {
        ...state,
        errorMsg: action.payload,
      };

    case SET_RESULT:
      return {
        ...state,
        resultFile: action.payload,
      };

    case RESET_BACKUP:
      return {
        ...state,
        phase: "ready",
        errorMsg: "",
        resultFile: null,
      };

    default:
      return state;
  }
};

export default backupReducer;
